import AccountSettingsIcon from "assets/svg/AccountSettingsIcon";
import DashboardIcon from "assets/svg/DashboardIcon";
import HelpSupportIcon from "assets/svg/HelpSupportIcon";
import LogoutIcon from "assets/svg/LogoutIcon";
import TransactionIcon from "assets/svg/TransactionIcon";
import WalletIcon from "assets/svg/WalletIcon";

interface NavItem {
  label: string;
  path: string;
  icon?: React.ReactNode; // Optional: If you want to use icons
  children?: NavItem[]; // Optional: For nested navigation items (e.g. submenus)
}

export const navigationData: NavItem[] = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />, // Example icon (use your actual icon here)
  },
  {
    label: "Wallet",
    path: "/dashboard/wallet",
    icon: <WalletIcon />, // Example icon
  },
  {
    label: "Transactions",
    path: "/dashboard/transactions",
    icon: <TransactionIcon />, // Example icon
  },
  {
    label: "Profile & Settings",
    path: "/dashboard/profile-settings",
    icon: <AccountSettingsIcon />, // Example icon
  },
  {
    label: "Support & Help",
    path: "/dashboard/help-support",
    icon: <HelpSupportIcon />, // Example icon
  },
  {
    label: "Logout",
    path: "/admin/logout",
    icon: <LogoutIcon width={24} height={24} />,
  },
];
